import { z } from "zod";

export const sessionReferenceSchema = z.string().regex(/^[a-f0-9]{64}$/);

export const sessionSummarySchema = z.object({
  id: sessionReferenceSchema,
  current: z.boolean(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string().datetime(),
  lastSeenAt: z.string().datetime(),
  expiresAt: z.string().datetime(),
});

export const sessionListResponseSchema = z.object({
  sessions: z.array(sessionSummarySchema),
});

export const sessionRevokeResponseSchema = z.object({
  revoked: z.literal(true),
  current: z.boolean(),
});

export const sessionRevokeOthersResponseSchema = z.object({
  revokedCount: z.number().int().nonnegative(),
});

export type SessionSummary = z.infer<typeof sessionSummarySchema>;
export type SessionListResponse = z.infer<typeof sessionListResponseSchema>;
export type SessionRevokeResponse = z.infer<typeof sessionRevokeResponseSchema>;
